import {
    IonContent, IonHeader, IonInput, IonPage, IonTitle, IonToolbar, useIonViewWillEnter,
} from '@ionic/react';
import './Blindbox.css';
import React, {useState, useRef, useEffect} from "react";
import {useHistory} from "react-router";
import {decrypt, encrypt, getQueryVariable} from "../../utils/commonFunction";
import {getBlindBoxInfoByNumber} from "./Service";
// @ts-ignore
import { Helmet } from 'react-helmet';

const BoxIndex: React.FC = () => {

    const [showRule, setShowRule] = useState<boolean>(false);
    const [inputs, setInputs] = useState<string[]>([]);
    const inputRefs = useRef<Array<HTMLIonInputElement | null>>([]);
    const [boxNumber, setBoxNumber] = useState<string>('');
    const [showTip, setShowTip] = useState<boolean>(false);
    const [showTipMsg, setShowTipMsg] = useState<string>('');
    const [showGreybackground, setShowGreybackground] = useState<boolean>(false);

    let history = useHistory();

    useIonViewWillEnter(() => {
        const boxNum = getQueryVariable("boxNum");
        if(boxNum){
            setBoxNumber(boxNum);
            const params = {
                boxNumber: boxNum
            }
            getBlindBoxInfoByNumber(params).then(ret => {
                if (ret.result == 10000 && ret.data.receiveDate) {
                        history.replace("/boxPrize?boxNum=" + encrypt(boxNum));
                    }
            }).catch(err => {
                console.log(err);
                // alert("查询失败，请稍后再试或联系我们。");
            });

        }

    });

    // useEffect(() => {
    //     const handleKeyDown = (e:any) => {
    //         const newInputs = [...inputs];
    //
    //         if (!/^\d$/.test(e.key)) {
    //             return;
    //         }
    //         if (newInputs.length >= 6) {
    //             return
    //         }
    //
    //         const index = newInputs.length - 1;
    //         newInputs[newInputs.length] = e.key || '';
    //         setInputs(newInputs);
    //         inputRefs.current[index + 1]?.setFocus();
    //         if (newInputs.length == 6) {
    //             if(boxNumber === "FY"+newInputs.join("")){
    //                 history.replace("/boxPrize?boxNum=" + encrypt(boxNumber));
    //                 //window.location.reload();
    //             }else {
    //                 setShowGreybackground(true)
    //                 setShowTip(true)
    //                 setShowTipMsg("您输入的号码有误，请仔细检查确认后重新输入")
    //             }
    //
    //         }
    //
    //     };
    //
    //     document.addEventListener('keydown', handleKeyDown);
    //
    //     return () => {
    //         document.removeEventListener('keydown', handleKeyDown);
    //     };
    // }, [inputs]);

    const showRules = () => {
        setShowGreybackground(true)
        setShowRule(true);
    }

    const closeRule = () => {
        setShowGreybackground(false)
        setShowRule(false);
    }

    const closeTipBox= () =>{
        setShowGreybackground(false)
        setShowTip(false)
        setShowTipMsg('')
    }

    // const handleInput = (event: CustomEvent, index: number) => {
    //
    //     const input = event.target as HTMLInputElement;
    //     const value = input.value;
    //     const newInputs = [...inputs];
    //     if (value === '') {
    //         newInputs.length = newInputs.length - 1;
    //         setInputs(newInputs);
    //         inputRefs.current[index - 1]?.setFocus();
    //     }
    //     // 只允许输入数字
    //     input.value = value.replace(/[^\d]/g, '');
    // };

    const handleInput = (event: any, index: number) => {
        const input = event.target as HTMLInputElement;
        const value = input.value;
        const newInputs = [...inputs];
        if (value === '' || value.length === 0) {
            newInputs.length = newInputs.length - 1;
            setInputs(newInputs);
            inputRefs.current[index - 1]?.setFocus();
            return;
        }
        if (!/^\d$/.test(value)) {return;}
        if (newInputs.length >= 6) {return}
        newInputs[newInputs.length] = value || '';
        setInputs(newInputs);
        inputRefs.current[index + 1]?.setFocus();
        if (newInputs.length == 6) {
            if(boxNumber === "FY"+newInputs.join("")){
                history.replace("/boxPrize?boxNum=" + encrypt(boxNumber));
                //window.location.reload();
            }else {
                setShowGreybackground(true)
                setShowTip(true)
                setShowTipMsg("您输入的号码有误，请仔细检查确认后重新输入")
            }
        }
    };

    return (
        <IonPage placeholder={""} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {/*<title>惊喜无限！精彩盲盒活动开启！</title>*/}
            <IonHeader placeholder={""} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <div>
                    <Helmet placeholder={""}>
                        <title>惊喜无限！精彩盲盒活动开启！</title>
                    </Helmet>
                    <meta name="viewport" content="width=750,target-densitydpi=device-dpi,user-scalable=no"/>
                    <meta content="telephone=no" name="format-detection"/>
                </div>
            </IonHeader>

            <IonContent fullscreen placeholder={""} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <div className="bb_index pr">
                    <a onClick={showRules} className="bb_rules"></a>
                    <div className="bb_bg">
                        <div className="bb_cont">
                            <div className="bb_yzm_cont">
                                <h1 className="bb_title">输入验证码，参与抽奖</h1>
                                <div className="bb_input_box bb_clearfix">
                                    {Array.from({length: 6}, (_, index) => (
                                        <IonInput
                                            placeholder={""}
                                            key={index}
                                            className={"input001"}
                                            type="text"
                                            //inputmode="numeric"
                                            pattern="[0-9]*"
                                            maxlength={1}
                                            //onFocus={()=>{console.log(index + ":focus")}}
                                            //autofocus={true}
                                            // @ts-ignore
                                            onIonChange={(e) => handleInput(e, index)}
                                            ref={(input) => (inputRefs.current[index] = input)}
                                            onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<!--活动弹窗部分-->*/}
                    {/*<!-------------------------灰色透明层--------------------->*/}
                    <div className={showGreybackground ? "greybackground_box" : "dn"}></div>
                    {/*<!-------------------------活动规则弹窗提示-------------------->*/}
                    <div className={showRule ? "tc02_box tc_rule" : "dn"}>
                        <div className="tc_bg">
                            <a className="close" onClick={closeRule}>关闭</a>
                            <div className="tc_cont_box">
                                <div className="tc_title_box">活动规则</div>
                                <div className="tc_tex_box">
                                    <p className="rule_text"><span>1</span>获得盲盒以后，扫码底座的二维码，输入对应的编号，即可获得随机大奖。</p>
                                    <p className="rule_text"><span>2</span>扫码获得的礼品奖励，完成线上线下信息填写（仅用于身份确认）。</p>
                                    <p className="rule_text"><span>3</span>获得奖励以后，7个工作日内进行奖励发放。</p>
                                    <p className="rule_text"><span>4</span>如中奖用户不同意填写个人信息，或不同意当面领取实物奖品，或超过中奖时间30天未联系，则视为弃奖。
                                    </p>
                                </div>
                                <div className="tc_tex_box">
                                    <p className="tc_tex_title rule_text">活动专属时间：</p>
                                    <p className="rule_text" >2023年7月3号-2024年7月3号 </p>
                                </div>
                                <div className="tc_tex_box">
                                    <p className="tc_tex_title rule_text">扫码有效时间： </p>
                                    <p className="rule_text">自中奖日期开始30天内可以进行兑换</p>
                                </div>
                                <div className="tc_tex_box">
                                    <p className="tc_tex_title rule_text">须知：</p>
                                    <p className="rule_text">该页面存在缓存，如您实际中奖内容与活动规则不一致，请清除手机缓存并刷新页面。 </p>
                                </div>
                                <div className="tc_tex_box">
                                    <p className="tc_tex_title rule_text">活动主办方：杭州浮云网络科技有限公司</p>
                                    <p className="rule_text">活动咨询电话：400-885-2091</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/*<!-------------------------去会员--------------------->*/}
                    <div className={showTip ? "tc02_box" : "dn"}>
                        <div className="tc_bg_box">
                            <a className="close" onClick={closeTipBox}>关闭</a>
                            <div className="detail_tc">
                                <p className="detail_tc_tex">{showTipMsg}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>

        </IonPage>

    );

};

export default BoxIndex;


